import React from 'react';
import { Box, Container, Grid, Typography } from '@mui/material';

const ContactUs = () => {


  return (
    <Box id="contact" className="contact-us">
      <Container>
        <Grid className='testimonial-container' container spacing={4} sx={{ marginTop: '30px' }}>
            <Grid item xs={12} md={6} data-aos="fade-up" data-aos-delay={"200"}>
                <Box className="testimonial-card">
                    <Typography variant="body1" className="address-title">
                        India 
                        <img src='/assets/india.png' alt='India' height={30} width={30}/>
                    </Typography>
                    <Typography variant="body1" className="address">
                        H.No. 751/3 Muktai maratha colony gokak road muchandi, Tal. Dist. belgaum, 590016 Karnataka
                    </Typography>
                    <Typography variant="body1" className="address">
                        <span className='email-lbl'>Email :</span> info@ssnm3technologies.com
                    </Typography>
                </Box>
            </Grid>
            <Grid item xs={12} md={6} data-aos="fade-up" data-aos-delay={"200"}>
                <Box className="testimonial-card">
                    <Typography variant="body1" className="address-title">
                        USA
                        <img src='/assets/united-states.png' alt='USA' height={30} width={30}/>
                    </Typography>
                    <Typography variant="body1" className="address">
                        30 N GOULD ST SHEERIDAN, WY 82801
                    </Typography>
                    <Typography variant="body1" className="address">
                        <span className='email-lbl'>Email :</span> info@ssnm3technologies.com
                    </Typography>
                </Box>
            </Grid>
        </Grid>

      </Container>
    </Box>
  );
};

export default ContactUs;
